import React, { Component } from "react";
import { HiExternalLink } from "react-icons/hi";
import sampleimage from './sampleimage.png';
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoMdArrowRoundForward } from "react-icons/io";
import * as loggingUtils from "./utils/loggingUtils";
import * as encryptUtils from "./encryptDecryptUtils";
const {
  REACT_APP_IS_MAINNET,
} = process.env;

class AuctionNFT extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let winningBid = null;
    if(this.props.auction.allAuctionBids.length > 0) {
      winningBid = this.props.auction.allAuctionBids[this.props.auction.allAuctionBids.length - 1];
    }

    // TODO undo immigrant parents hard coding

    return (
        <div className="h-128 justify-center flex flex-col">
          {
            this.props.auction.mediaType === 2
              ?
            <img className="w-96 h-96 object-cover rounded-lg"src={this.props.auction.imagePinata} />
              :
            <video
              className="w-96 h-96 object-cover rounded-lg"
              src={this.props.auction.animation_url}
              controls
              muted="muted"
              autoplay="autoplay"
            />
          }
          <div className="text-lg font-medium mt-2 text-black dark:text-white">
            {
              this.props.auction.name.includes("Immigrant Parents")
                ?
              "Immigrant Parents (live with the402)"
                :
              this.props.auction.name
            }
          </div>
          {
            winningBid != null
              ?
            <div className="flex items-center cursor-pointer text-md font-medium text-gray-500 dark:text-zinc-500">
              { this.props.auction.bidder.substring(0, 5) + "..." + this.props.auction.bidder.substring(this.props.auction.bidder.length - 5) }
              <HiExternalLink className="ml-2" onClick={
                () => {
                  loggingUtils.logEvent(
                    this.props.account != null
                      ? this.props.account.address
                      : encryptUtils.getWalletUnconnectedUserId(),
                    "auction_page",
                    "auction_page_visit_winning_bid_link",
                    "info",
                    "https://the402.xyz",
                    {}
                  );
                  if(REACT_APP_IS_MAINNET !== "testnet") {
                    window.open("https://etherscan.io/tx/" + winningBid.transactionHash, "_blank");
                  } else {
                    window.open("https://goerli.etherscan.io/tx/" + winningBid.transactionHash, "_blank");
                  }
                }
              }/>
            </div>
              :
            null
          }
        </div>
    );
  }
}

export default AuctionNFT;
